import { useMemo } from 'react'
import { useAppSelector } from './useRedux'
import { getUserInfo, getCemFeatures } from '../../store/userInfo/userInfoSlice'
import { isFeatureFlagEnabled } from '../../rsmCoreComponents/utils/featureFlagUtils'
import { FeatureFlag } from '../constants/constants'

export const useFeatureFlag = (
  featureName: FeatureFlag,
  matchType: 'all' | 'any' = 'all',
): boolean => {
  const userInfo = useAppSelector(getUserInfo)
  const cemFeatures = useAppSelector(getCemFeatures)

  return useMemo(
    () =>
      isFeatureFlagEnabled(
        featureName,
        userInfo.emailAddress,
        cemFeatures,
        matchType,
      ),
    [featureName, userInfo.emailAddress, cemFeatures, matchType],
  )
}

export default useFeatureFlag
